
import { EditableField } from '@models/editable-field';
import { translate } from '@components/i18n';
import moment from 'moment';

export const columns = [
    {
        title: translate('columns.clientCode'),
        dataIndex: 'codigo',
        sorter: false,
        width: '10%',
    },
    {
        title: translate('columns.client'),
        dataIndex: 'nome',
        sorter: false,
        width: '10%',
    },
    {
        title: translate('columns.cnpj'),
        dataIndex: 'cnpj',
        sorter: false,
        width: '15%',
    },
    {
        title: translate('columns.registerBy'),
        dataIndex: 'usuarioCadastro',
        sorter: false,
        width: '12%',
        render: (_, item) => {
            const login = item?.usuarioCadastro?.login
            return (
                <span>
                    {login || '-'}
                </span>
            );
        },
    },
    {
        title: translate('columns.registerDate'),
        dataIndex: 'dataCadastro',
        sorter: false,
        width: '12%',
        render: (text) => {
            const date = text ? moment(text).format('DD/MM/YYYY') : undefined
            return (
                <span>
                    {date || '-'}
                </span>
            );
        },
    },
];

export function editableFields({ editable = false, optionsItems }): EditableField[] {
    return [
        {
            name: 'client',
            label: translate('forms.labels.client'),
            type: 'select',
            multiple: false,
            options: optionsItems,
            disabled: !editable,
            span: 24,
            rules: [
                {
                    required: true,
                    message: translate('forms.rules.obg'),
                },
            ],
        },
    ];
}
